<template>
  <div class="compony">
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item>填充展商信息<span style="font-size:12px; margin-left: 20px;">(备注：联系人邮箱为必填项，以便海外客户能联系到您，其它可以根据需要选填。)</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <el-col :span="18">
        <!-- size="small" -->
        <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="magezineForm" label-position="right"  label-width="300px">
          <template v-for="(item,ind) in allList">
              <template v-if="item.fieldKey != 'atrCountry' && item.fieldKey != 'atrBthType'  && item.fieldKey != 'atrProvince'  && item.fieldKey != 'atrCity' && item.fieldKey != 'atrBthArea' && item.fieldKey != 'atrCardNum'  && item.fieldKey != 'atrLogo' ">
                <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                <template v-if="item.fieldKey == 'atrTel' || item.fieldKey == 'atrFax' ">
                    <el-input v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" ></el-input>
                </template>
                <template v-else>
                   <el-input :disabled="item.fieldKey == 'atrName' || item.fieldKey == 'bthCode' || item.fieldKey==='atrLogName' || item.fieldKey==='atrPwd'"  :type=" ( item.fieldKey == 'atrIntro' ||  item.fieldKey == 'atrEIntro' ) ? 'textarea': 'text'"  v-model="form[item.fieldKey]" :placeholder="item.fieldHolder"></el-input>
                </template>
                </el-form-item>
              </template>

              <!-- 展位面积 证件数量上限 -->
              <template v-if="item.fieldKey == 'atrBthArea' || item.fieldKey == 'atrCardNum'  || item.fieldKey == 'atrBthType' ">
                <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                  <el-input   v-model.trim="form[item.fieldKey]" @keyup.native="inputChange($event,item.fieldKey)" :placeholder='item.fieldHolder' disabled></el-input>
                </el-form-item>
              </template>

              <!--<template v-if="item.fieldKey == 'atrCountry'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeCountry'>
                    <el-option v-for="(item, index) in countryList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
                  </el-select>
                </el-form-item>
              </template>
                <template v-if="item.fieldKey == 'atrProvince'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :key="ind"  :rules="rulesFn(item)">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeProvince' :disabled="provinceList.length<=0">
                    <el-option v-for="(item, index) in provinceList" :key="index" :label="item.zptProvince" :value="item.zptProvince"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'atrCity'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey"  :key="ind"  :rules="rulesFn(item)">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" :disabled="cityList.length<=0">
                    <el-option v-for="(item, index) in cityList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
                  </el-select>
                </el-form-item>
              </template>-->

              <template v-if="item.fieldKey == 'atrLogo'">
                  <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                    <el-input v-model="form[item.fieldKey]" style="display:none"/>
                    <Upload :isFaceRead="false" :mediaUrl.sync="form[item.fieldKey]"  :typeString = '"E"'/>
                  </el-form-item>
              </template> 
        
          </template>

          <el-form-item>
            <el-button type="primary" :style="buttonStyle" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@/api'
import Upload from '@/components/Upload'
import tools from '../utils/tools.js';
import {validAddress,validAddress1,validComName,validZipCode,validIntro,validTel,validEmail,validMobile } from '@/utils/validator'
export default {
  data: () => ({
    countryList: [],    //国家
    provinceList: [],  //省份
    cityList: [],    //城市
    form: {},
    rules: {},
    isPC: true,
    allList:[],
    bthTypeList: ['标摊', '光地'],
    buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {}
  }),

  components: {
    Upload
  },
  async mounted() {
    this.getsaasfield()
  },
  methods: {
    validateProvince (rule, value, callback) {
      if (rule.required) { // 如果省份必填
        if (this.form.atrCountry === '中国' || this.form.atrCountry === undefined) { // 已选择中国或没有国家选项
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    validateCity (rule, value, callback) {
      if (rule.required) {
        if (this.form.atrProvince) {
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    validateAtrName (rule, value, callback) {
       if(value || rule.required){
          if (!validComName(value)) {
           callback(new Error(rule.message))
          } else {
            callback()
          }
       }else{
         callback()
       }
    },
    validateAtrIntro (rule, value, callback) {
       if(value){
          if (!validIntro(value)) {
           callback(new Error(rule.message))
          } else {
            callback()
          }
       }else{
         callback()
       }
    },
     validateAtrZipCode(rule, value, callback) {
      if(value || rule.required){
        if (!validZipCode(value)) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
      }else{
         callback()
       }
 
    },
    validateEmail (rule, value, callback) {
      if(value || rule.required){
        if (!validEmail(value)) {
          callback(new Error(rule.message))
        } else {
          callback()
        }
      }else{
        callback()
      }
    },

   validateAddress  (rule, value, callback) {
     if(value){
      if (!validAddress1(value)) {
        callback(new Error(rule.message))
      } else {
        callback()
      }
      }else{
       callback() 
      }
    },

   validateTel  (rule, value, callback) {
     if(value || rule.required){
      if (!validTel(value)) {
        callback(new Error(rule.message))
      } else {
        callback()
      }
      }else{
        callback()
      }
    },
    validateTel1  (rule, value, callback) {
     if(value || rule.required){
      if (!validMobile(value)) {
        callback(new Error(rule.message))
      } else {
        callback()
      }
      }else{
        callback()
      }
    },
    rulesFn(item){
      var temp = ''
      var rulesData= {
        atrCountry: [{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName}],
        atrProvince:[{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName,validator: this.validateProvince}],
        atrCity:[{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName,validator: this.validateCity}],
        atrZipCode: [{ required: item.required, trigger: 'change',message: '请输入正确的'+item.fieldName, validator: this.validateAtrZipCode }],
        atrAddress: [{ required: item.required, trigger: 'change',message: '请输入不要超过200个字符', validator: this.validateAddress }],
        atrEAddress: [{ required: item.required, trigger: 'change',message: '请输入不要超过200个字符', validator: this.validateAddress }],
        atrIntro: [{ required: item.required, trigger: 'blur',message: '请输入不要超过400个字符', validator: this.validateAtrIntro }],
        atrEIntro: [{ required: item.required, trigger: 'blur',message: '请输入不要超过400个字符', validator: this.validateAtrIntro }],
        atrLogo: [{ required: item.required, trigger: 'change', message: '请上传'+item.fieldName}],
        atrFax: [{ required: item.required, trigger: 'change', message: "请输入正确"+item.fieldName,validator: this.validateTel}],
        atrTel: [{ required: item.required, trigger: 'change', message: "请输入正确"+item.fieldName,validator: this.validateTel1}],
//      atrName: [{ required: item.required, trigger: 'change',message: item.fieldName+'请输入2-100个字符'}],
//      atrSName: [{ required: item.required, trigger: 'change',message: item.fieldName+'请输入不要超过20个字符', validator: this.validateAtrName }],
        other:{required:item.required, message: item.fieldName+'不能为空', trigger: 'change'},
        select:{required:item.required, message: '请选择', trigger: 'change',validator:function(rule, value, callback){
          if( value || rule.required ){
              if (value == '') {
                callback(new Error('请选择'))
              } else {
                callback()
              }
          }else{
              callback()
          }
        }},
        atrEmail: [{ required: item.required, trigger: 'blur', message: "请输入正确"+item.fieldName, validator: this.validateEmail}],
      }
      switch (item.fieldKey){
      case 'atrCountry':
      case 'atrProvince':
      case 'atrCity':
      case 'atrEmail':
      case 'atrZipCode':
      case 'atrSName':
      case 'atrTel':
      case 'atrFax':
      case 'atrLogo':
      case 'atrIntro':
      case 'atrEIntro':
      case 'atrAddress':
      case 'atrEAddress':
          temp = item.fieldKey
          break;
      default: 
          temp = 'other'
          break
      }
      return rulesData[temp]
    },
    getsaasfield(){
      api.getsaasfield({type:"exhibitor"}).then(res => {
        if (res.data.code === 200) {
          this.allList =[]
          var _data = res.data.data
          // _data[0].enable = 0
          for(var i = 0;i<_data.length;i++){
            if(_data[i].enable == 1){
              this.allList.push(_data[i])
            }
          }
          for(var j=0;j<this.allList.length;j++){
            this.$set( this.form,this.allList[j].fieldKey,"")
          }
          this.$nextTick(() => {
            this.getData()
          })
        }
      })
    },
    //禁止input输入 数字以外的字符
    inputChange(ev,val){
      this.form[val] = this.form[val].replace(/[^\d]/g,'');
    },
    //国家切换
    changeCountry(){
        if(this.form.atrCountry !='中国'){
          this.form.atrProvince= ''
          this.form.atrCity =''
          this.cityList =[]
          this.provinceList =[]
        }else{
          api.getallprovinces().then((res) => {
            this.provinceList = res.data.data
          })
          this.getCity()
        }
    },
    //切换省份
    changeProvince(){
      this.form.atrCity =''
      this.getCity()
    },

    //跟据省份获取城市
    getCity(){
      if(this.form.atrProvince && this.form.atrProvince !=""){
          api.getallcitysbyprovince({zptProvince:this.form.atrProvince}).then((res)=>{
              this.cityList = res.data.data
          })
      }else{
          this.cityList = []
      }
    },
    //获取会刊信息
    getData(){
      return new Promise((resolve, reject)=>{
        api.getactordetails().then((res)=>{
          if(res.data.code =='200'){
            var _data = res.data.data
            localStorage.setItem('atrEName',_data.atrEName)
            for (let i in this.form) {
              if (i !== 'atrBthArea') {
                this.form[i] = _data[i]?''+_data[i]+'':''
              } else {
                this.form[i] = _data[i]?''+_data[i]+'':'0'
              }
            }
            if(this.form.hasOwnProperty("atrCardNum")  ){
              this.form.atrCardNum = this.form.atrCardNum ? this.form.atrCardNum : 0
            }
            this.form = JSON.parse(JSON.stringify(this.form))
            api.getallcountrys().then((res) => {      
              this.countryList = [{zptArea: "国内",zptCity: "中国"}, ...res.data.data]
            })
            if ((this.form.atrCountry && this.form.atrCountry === '中国') || this.form.atrCountry===undefined) {
//            api.getallprovinces().then((res) => {
//              this.provinceList = res.data.data
//            })
              this.getCity()
            }else{
              this.provinceList = [];
              this.citysList= [];
            }
            resolve(_data)
          }else{
            reject("")
          }
        })
      })
    },
    onSubmit() {
        for (let i in this.form) {
            if( typeof this.form[i] != 'object'){
               this.form[i] = (this.form[i]).toString().replace(/^\s+|\s+$/g,"")
            }
        }
        this.$refs['magezineForm'].validate((valid) => {
          if (valid) {

            if(this.form.hasOwnProperty("atrCardNum")  ){
              this.form.atrCardNum = parseInt(this.form.atrCardNum) || 0
            }
           
            var paramt = JSON.parse(JSON.stringify(this.form))              
            api.updateactor(paramt).then((res) => {
              if (res.data.code === 200) {
                this.$notify({
                  title: '保存成功',
                  type: 'success',
                    duration: 2000
                })
                this.getData()
              }
            })
          } else {
            this.$notify({
              title: '请检查表单填写项是否符合规范！',
              type: 'error'
            })
            return false
          }
        })
    },

  }
}
</script>
<style lang="less">

.el-form-item.is-error .clearError input.el-input__inner{
  border: 1px solid #DCDFE6 !important;
}
.blue {
  color: #409eff;
}

.title {
  margin-bottom: 30px;
}

.col-1-fix {
  padding-left: 0 !important;
}
.el-input__inner{
  font-weight: bold !important;
}
.el-textarea__inner{
  font-weight: bold !important;
}
@media screen and (max-width:540px){
  .compony{
    .el-col-18{
      width: 100% !important;
    }
    .el-form-item__error{
      width: 100%;
      text-align: right;
    }
    .el-form-item__label{
      font-size:14px;
      text-align: left !important;
      float: none !important;
    }
    .el-form-item__content{
      width: 100% !important;
      margin-left: 0 !important;
    }
    .el-input__inner{
      border:0;
      text-align: left;
      font-weight: bold !important;
    }
    .el-textarea__inner{
      font-weight: bold !important;
    }
    .el-form-item{
      border-bottom: 1px solid #ededed;
    }
    .dash-upload{
      width:100%;
    }
    .noRequire .el-form-item__label::before{
      content: '';
      display: inline-block;
      width: 10px;
    }
    .cccItem{
      border:0;
      margin:0;
      .el-form-item__error{
        top: 240%
      }
    }
    .pad0{
      padding-right:0 !important;
    }
    .telOrFax{
      padding:0 10px;
      .el-input__inner{
        padding:0;
        border: 1px solid #ededed;
        text-align: center;
      }
    }
  }
}
</style>
